<template>
  <div class="video-container">
    <video
      ref="videoRef"
      :src="videoSource"
      :autoplay="config.autoPlay"
      :loop="config.loop"
      :muted="muteVideo"
      @loadeddata="isVideoLoaded = true"
      @loadstart="isVideoLoaded = false"
      @error="handleVideoError"
      class="video-fill"
      :class="{ 'video-hidden': !isVideoLoaded }"
    />
    <!-- <img
      v-if="!isVideoLoaded"
      src="@/assets/images/placeholder_video.png"
      alt="Video loading placeholder"
      class="placeholder-image"
    /> -->
  </div>
</template>
<script lang="ts">
export default {
  name: "VideoWidget",
};
</script>
<script setup lang="ts">
import {
  computed,
  defineProps,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
  queueAudioPlaying: {
    type: Boolean,
    required: true,
  },
});

//mute video when audio starts
const videoRef = ref<HTMLVideoElement | null>(null);
const isActuallyMuted = ref(false);
const isVideoLoaded = ref(false);
let unmuteTimeout: number | null = null;
watch(
  () => props.queueAudioPlaying,
  (newVal) => {
    if (newVal) {
      // mute immediately when audio starts
      isActuallyMuted.value = true;
      if (unmuteTimeout) {
        clearTimeout(unmuteTimeout);
        unmuteTimeout = null;
      }
    } else {
      // unmute after 1 second when audio stops
      unmuteTimeout = window.setTimeout(() => {
        isActuallyMuted.value = false;
        unmuteTimeout = null;
      }, 1000);
    }
  },
  { immediate: true }
);

const muteVideo = computed(() => {
  if (props.config.muted) return true;
  return isActuallyMuted.value;
});

//src video offline
const isOnline = ref(navigator.onLine);
const androidVideoPath = ref("");
const encodeUrlVideo=(url:any)=>{
  const encodedUrl = encodeURIComponent(url);
  return encodedUrl;
}
const videoSource = computed(() => {
  if (isOnline.value && props.config?.src) {
    // Handle both string and object formats
    if (typeof props.config.src === 'string') {
      return props.config.src;
    } else if (props.config.src && typeof props.config.src === 'object' && 'url' in props.config.src) {
      return props.config.src.url;
    }
    return props.config.src;
  }
  return androidVideoPath.value || "";
});

const setAndroidVideoPath = (path: string) => {
  if (path.startsWith("data:video/mp4;base64,")) {
    androidVideoPath.value = path;
    console.log("Received base64 video data");
  } else {
    console.warn("Invalid video path format");
  }
};

const updateOnlineStatus = () => {
  isOnline.value = navigator.onLine;
  console.log(
    `Connection status changed: ${isOnline.value ? "Online" : "Offline"}`
  );
};

function handleVideoError() {
  console.error('Error loading video:', videoSource.value);
  isVideoLoaded.value = false;
}

onMounted(() => {
  (window as any).setAndroidVideoPath = setAndroidVideoPath;
  if ((window as any).AndroidInterface) {
    (window as any).AndroidInterface.getVideoPath();
  } else {
    console.log("Android interface not available");
  }
  updateOnlineStatus();
  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);
});

onBeforeUnmount(() => {
  if (unmuteTimeout) clearTimeout(unmuteTimeout);
  window.removeEventListener("online", updateOnlineStatus);
  window.removeEventListener("offline", updateOnlineStatus);
});
</script>
<style scoped>
.video-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.video-fill {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block !important;
}

.video-hidden {
  opacity: 0;
}

.placeholder-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50% !important;
  height: 50% !important;
  object-fit: contain;
  display: block;
}
</style>
